
<div class="row">
    <div class="col-12">
  
        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'DEPARTMENTS.DEPARTMENTS_LIST' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-primary btn-sm" (click)="onCreate()">
                        <i class="bi bi-plus-circle"></i> {{ 'ADD' | translate }}
                    </button>
                </div>
            </div>
            <div class="card-body">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="name">{{ 'DENOMINATION' | translate }}</th>
                            <th scope="col" class="parent">{{ 'DEPARTMENTS.SUPERIOR_DEPAR' | translate }}</th>
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="departments.length > 0">
                        <tr *ngFor="let department of departments; let i = index">
                            <td class="name">{{ department.name }}</td>
                            <td class="name">{{ department.parent.name }}</td>
                            <td class="action">
                                <button type="button" class="btn btn-light" placement="top" ngbTooltip="{{ 'ACTION' | translate }}">
                                    <i class="bi bi-eye"></i>
                                </button>
                                <button type="button" class="btn btn-light" (click)="onEdit(i)" placement="top" ngbTooltip="{{ 'EDIT' | translate }}">
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                                 <button type="button" class="btn btn-light" (click)="onConfirm([department.id])"
                                    placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="departments.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="3">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="3">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>

    </div>
</div>